module.exports = __webpack_public_path__ + "static/say-nothing-a-true-story-of-murder-and-memory-in-northern-ireland-10bd5439f7631c406a6fd4defdb2be6f.jpg";